'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TransmuteCollection = require('./TransmuteCollection');

var _immutable = require('immutable');

var empty = function empty() {
  return undefined;
};

_TransmuteCollection.get.implement(Array, function (key, subject) {
  return subject[key];
});
_TransmuteCollection.get.implement(null, empty);
_TransmuteCollection.get.implement(Object, function (key, subject) {
  return subject[key];
});
_TransmuteCollection.get.implement(undefined, empty);

_TransmuteCollection.get.implementInherited(_immutable.Iterable, function (key, subject) {
  return subject.get(key);
});

exports.default = _TransmuteCollection.get;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_get.js
// module id = 50
// module chunks = 0 1